import React, { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/customernotifications/Notifications.css";

/* ── Bell Icon ── */

const SgcBellIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const Notifications = () => {
  const { baseUrl } = useContext(AppContext);
  const [notifications, setNotifications] = useState([]);
  const getCustomerId = () => localStorage.getItem("customerId");

  const viewAllNotifications = () => {
    const escustomerId = getCustomerId();
    if (!escustomerId) return;

    axios
      .get(`${baseUrl}/customer/notifications/viewAllNotifications`, {
        params: { escustomer_id: escustomerId },
      })
      .then((response) => {
        setNotifications(response.data.notifications);
      })
      .catch((error) => console.log(error));
  };

  const markAllRead = () => {
    const escustomerId = getCustomerId();

    axios
      .post(`${baseUrl}/customer/notifications/markAllRead`, {
        escustomer_id: escustomerId,
      })
      .then(() => viewAllNotifications())
      .catch((error) => console.log(error));
  };

  const markAsRead = (id) => {
    const escustomerId = getCustomerId();

    axios
      .post(`${baseUrl}/customer/notifications/updateNotification`, {
        id: id,
        escustomer_id: escustomerId,
      })
      .then(() => viewAllNotifications())
      .catch((error) => console.log(error));
  };

  const deleteNotification = (id) => {
    const escustomerId = getCustomerId();

    axios
      .post(`${baseUrl}/customer/notifications/deleteNotification`, {
        id: id,
        escustomer_id: escustomerId,
      })
      .then(() => viewAllNotifications())
      .catch((error) => console.log(error));
  };
  // const viewAllNotifications = () => {
  //   axios
  //     .get(`${baseUrl}/customer/notifications/viewAllNotifications`)
  //     .then((response) => {
  //     console.log(response.data);
  //       setNotifications(response.data.notifications);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // const markAllRead = () => {
  //   axios
  //     .post(`${baseUrl}/customer/notifications/markAllRead`)
  //     .then((response) => {
  //       console.log(response.data);
  //       viewAllNotifications();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // const deleteNotification = (id) => {
  //  axios
  //     .post(`${baseUrl}/customer/notifications/deleteNotification`, {
  //       id: id,
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       viewAllNotifications();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  useEffect(() => {
    viewAllNotifications();
  }, []);
  return (
    <Container fluid>
      {/* Header */}
      <div className="sgc-notifpage-header">
        <h1 className="sgc-notifpage-title">Notifications</h1>
        <button className="sgc-notifpage-mark-btn" onClick={markAllRead}>
          Mark all read
        </button>
      </div>
      {/* Notification Items */}
      {notifications.map((notif) => (
        <div
          key={notif.id}
          className={`sgc-notifpage-item${notif.is_read === false ? " sgc-notifpage-unread" : ""}`}
          onClick={() => !notif.is_read && markAsRead(notif.id)}
          style={{ cursor: "pointer" }}
        >
          <div className="sgc-notifpage-icon">
            <SgcBellIcon />
          </div>

          <div className="sgc-notifpage-info">
            <p className="sgc-notifpage-item-title">{notif.title}</p>
            <p className="sgc-notifpage-item-body">{notif.description}</p>
          </div>

          <button
            className="btn btn-danger btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              deleteNotification(notif.id);
            }}
          >
            Delete
          </button>
        </div>
        // <div
        //   key={notif.id}
        //   className={`sgc-notifpage-item${
        //     notif.is_read === false
        //       ? " sgc-notifpage-unread"
        //       : ""
        //   }`}
        // >
        //   {/* Icon */}
        //   <div className="sgc-notifpage-icon">
        //     <SgcBellIcon />
        //   </div>
        //   {/* Text */}
        //   <div className="sgc-notifpage-info">
        //     <p className="sgc-notifpage-item-title">
        //       {notif.title}
        //     </p>
        //     <p className="sgc-notifpage-item-body">
        //       {notif.description}
        //     </p>
        //   </div>
        //   {/* Delete Button */}
        //   <button
        //     className="btn btn-danger btn-sm"
        //     onClick={() => deleteNotification(notif.id)}
        //   >
        //     Delete
        //   </button>

        // </div>
      ))}
    </Container>
  );
};

export default Notifications;
